import Collection_Base from 'collection/base';
import Model_Integration_Log from 'model/integration_log';

export default Collection_Base.extend({
    model: Model_Integration_Log
});